module.exports = __webpack_public_path__ + "img/home-banner2.e8241407.jpg";